"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const __1 = require("../..");
const helpers_1 = require("../../lib/helpers");
const SearchContext_1 = __importDefault(require("../../contexts/SearchContext"));
const usePaginate_1 = __importDefault(require("../../hooks/SWR/usePaginate"));
const Search = (props) => {
    const { paginateProps, loadOnFocus } = props;
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    const [inputFocused, setInputFocused] = react_1.useState(false);
    const [inputValue, setInputValue] = react_1.useState('');
    const searchInputRef = react_1.useRef(null);
    const [searchHits, setSearchHits, searchHitPaginator] = usePaginate_1.default(paginateProps(inputValue, inputFocused));
    const contextValue = {
        loadOnFocus,
        inputFocused,
        setInputFocused,
        searchHits,
        setSearchHits,
        searchHitPaginator,
        searchInputRef,
        inputValue,
        setInputValue,
    };
    return (react_1.default.createElement(SearchContext_1.default.Provider, { value: contextValue },
        react_1.default.createElement("div", Object.assign({}, primitiveProps), props.children)));
};
exports.default = __1.withJourney('j-search', Search);
